/**
 * Editorial-dash template that creates a Question instance configured for
 * binary yes-or-no responses.
 *
 * A creation-time preset registered in the `templates` config slot of the
 * new-space picker. Choosing this tile creates a Question instance with the
 * `Dialogue` feature enabled; the actual yes/no UI is implemented by that
 * feature. The template's only job is contributing the picker tile and the
 * feature flag applied at creation.
 */

import type { SpaceTemplate } from 'feature/editorial-dash/spaces';
import { t } from 'util/stdtypes';

export const DialogueTemplate: SpaceTemplate = {
    key: 'dialogue',
    label: t('dialogue_template.label', 'Dialogue'),
    descriptionLabel: t('dialogue_template.description', 'Ask users to respond to your question with a simple “yes” or “no” answer.'),
    imageUrl: 'images/dialogue.svg',
    structureKey: 'question',
    featuresEnabled: ['Dialogue'],
};
